import React from "react";
import { cn } from "@sys42/utils";
import { useLocation } from "@reach/router";
import { useIntl, changeLocale, IntlContextConsumer } from "gatsby-plugin-intl";
import Cookies from "universal-cookie";
import * as styles from "./styles.module.css";
import imgGlobe from "./globe.svg";

const cookies = new Cookies();
const cookieDomain = process.env.GATSBY_DEFAULT_COOKIE_DOMAIN;

function setNetlifyLanguageCookie(langKey) {
  const days = 365;
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  cookies.set("nf_lang", langKey, { path: "/", domain: cookieDomain, expires });
}

export function LanguageSwitcher({ className }) {
  const intl = useIntl();
  const { locale } = intl;

  const location = useLocation();
  const currentUrl = location.pathname;

  // const homeLink = `/${locale}/`.replace(`/${defaultLangKey}/`, '/');

  let currentUrlWithLang;
  if (currentUrl === `/${locale}` || currentUrl.indexOf(`/${locale}/`) === 0) {
    currentUrlWithLang = currentUrl;
  } else {
    currentUrlWithLang = `/${locale}${currentUrl}`;
  }

  /*  const langsMenu = getLangs(langs, langKey, getUrlForLang(homeLink, currentUrl)).map((item) => ({
      ...item,
      langKey:
      link: item.link.replace(`/${defaultLangKey}/`, '/')
    }));*/

  function handleClickLanguage(e, language) {
    e.preventDefault();
    changeLocale(language);
    setNetlifyLanguageCookie(language);
  }

  return (
    <section className={cn(className, styles.languageSwitcher)}>
      <img
        src={imgGlobe}
        height={20}
        width={20}
        alt={intl.formatMessage({ id: "selectLanguage" })}
      />
      <IntlContextConsumer>
        {({ languages }) =>
          languages.map((language) =>
            language === locale ? (
              <span lang={language} key={language}>
                {intl.formatMessage({
                  id: `selectLanguage.languageName.${language}`,
                })}
              </span>
            ) : (
              <a
                key={language}
                rel="alternate"
                hrefLang={language}
                lang={language}
                href={currentUrlWithLang.replace(
                  `/${locale}/`,
                  `/${language}/`
                )}
                onClick={(e) => handleClickLanguage(e, language)}
              >
                {intl.formatMessage({
                  id: `selectLanguage.languageName.${language}`,
                })}
              </a>
            )
          )
        }
      </IntlContextConsumer>
    </section>
  );
}
